import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { AssessmentDetails } from "Assessments";
import { LeDetails } from "LearningEngagement";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";

export default store => ({
  path: ":module_id",
  component: withAsyncRouteLoading(() =>
    Promise.all([import("./components")]).then(([indexModule]) => {
      return indexModule.default;
    })
  ),
  childRoutes: [
    AssessmentDetails(store),
    LeDetails(store),
    ClassRoomDetails(store),
  ],
});
